export default __webpack_public_path__ + "static/media/pearlcatcher.7023482c.png";